import { DashboardType } from '@nirvana/shared/dtos/types/generic-dashboards/gz-console';

export const dashboardsWithExtJSInjection = [DashboardType.ASM];
